function getType(value) {
    if (Array.isArray(value)) {
        return "array";
    }
    if (value === null) {
        return "null";
    }
    // this looks stupid :shrug:
    if (typeof value === "object" ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean") {
        return typeof value;
    }
    return "undefined";
}
function identity(value) {
    return value;
}
const typeConverter = {
    "": identity,
    any: identity,
    array: Array,
    boolean: Boolean,
    string: String,
    number: Number,
    object: Object,
    null: () => null,
    undefined: () => undefined
};
function getComponentPropertyValue(value, propertyConfig) {
    const { expectedTypes, convertTo } = propertyConfig;
    if (expectedTypes.includes(getType(value)) ||
        expectedTypes.includes("any") ||
        expectedTypes.length === 0) {
        return value;
    }
    return typeConverter[convertTo](value);
}

export { getComponentPropertyValue, getType };
//# sourceMappingURL=componentPropertyTypesHelper.js.map
